import {
  CaretRightOutlined,
  DatabaseOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import { useRouter } from "next/router";
import { memo, useMemo } from "react";

import { StyledContainer, StyledWrapper, StyledName } from "./styles";
import ReactGA from "react-ga4";
import { useShallowPush } from "utils/router/shallow-push";
interface DropdownLabelProps {
  open?: boolean;
  name: string;
  id: string;
  toggle: () => void;
}

const DropdownLabel = memo(({ open, name, id, toggle }: DropdownLabelProps) => {
  const { push } = useShallowPush();
  const iconRotation = useMemo(() => (open ? 90 : 0), [open]);

  const onNameClick = async () => {
    if (process.env.NODE_ENV === "production") {
      ReactGA.send({
        hitType: "pageview",
        page: `/database/${id}/summary`,
        title: "User Hit This Route",
      });
    }
    await push(`/database/${id}/summary`);
  };

  return (
    <StyledContainer className="flex">
      <StyledWrapper
        className={`flex gap-x-1 overflow-hidden prevent-color-propagation ${
          open ? "open" : ""
        }`}>
        <div className="flex items-center" onClick={toggle}>
          <CaretRightOutlined rotate={iconRotation} />
        </div>

        <div className="flex items-center" onClick={toggle}>
          <DatabaseOutlined />
        </div>

        <StyledName
          onClick={toggle}
          className="overflow-hidden text-ellipsis whitespace-nowrap">
          {name}
        </StyledName>

        <div className="flex items-center opacity-50">
          <RightCircleOutlined onClick={onNameClick} />
        </div>
      </StyledWrapper>
    </StyledContainer>
  );
});

export default DropdownLabel;
